import { useState, useEffect, useCallback } from 'react';
import type { Override, PaginationInfo } from '../api/types';
import { fetchOverrides, type ListParams } from '../api/client';

export function useOverrides(params: ListParams) {
  const [data, setData] = useState<Override[]>([]);
  const [pagination, setPagination] = useState<PaginationInfo>({
    page: 1,
    per_page: 50,
    total: 0,
    total_pages: 0,
  });
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    fetchOverrides(params)
      .then((res) => {
        setData(res.data);
        setPagination(res.pagination);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [JSON.stringify(params)]);

  useEffect(() => {
    load();
  }, [load]);

  const removeItem = useCallback((id: number) => {
    setData(prev => prev.filter(item => item.id !== id));
  }, []);

  return { data, pagination, loading, reload: load, removeItem };
}
